module.exports = __webpack_public_path__ + "static/media/worst-taste.ead47bb1.png";